export default __webpack_public_path__ + "static/media/projectInfo.6ac4a752.svg";